import { useEffect, useState } from "react";
import { useGetRevenueMachineApi, useGetStoreOfAccountApi } from "../../hooks";
import { Dropdown, Select } from "antd";
import { useAuthStore, useRevenueMachine, useRevenueStore } from "../../store";
import {
  formatMonthDate,
  formatNumberWithCommas,
  getStartEndOfCurrentMonth,
} from "../../helper";
import { ScheduleOutlined } from "@ant-design/icons";
import { RangeCalendar } from "@nextui-org/react";
import { emptyIcon } from "../../assets";
import {
  CardItemRevenueStore,
  FooterFilterMobile,
  LoaderCustom,
} from "../../components";
import { useLocation, useNavigate } from "react-router-dom";
import path from "../../ultils/path";

export default function RevenueMachineUserPage() {
  const { allStoreOfAccount } = useGetStoreOfAccountApi();
  const [listStoreSelect, setListStoreSelect] = useState([]);
  const [isShowCalender, setIsShowCalender] = useState(false);
  const [listRevenueMachine, setListRevenueMachine] = useState<any>();
  const [dataRevenue, setDataRevenue] = useState<any>();

  // state store
  const { setStoreId, storeId } = useRevenueMachine();

  const { setEndDate, setStartDate, startDate, endDate } = useRevenueStore();

  // api
  const { revenueMachine, isLoading } = useGetRevenueMachineApi();

  const location = useLocation();
  const storeCode = location.state?.storeCode;
  // const dataRevenue = location.state?.dataRevenue;

  useEffect(() => {
    if (storeCode) {
      setStoreId(storeCode);
    }
  }, [storeCode]);

  const { token } = useAuthStore();
  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      navigate(path.SIGN_IN);
    }
  }, []);

  useEffect(() => {
    if (allStoreOfAccount?.data) {
      const listStoreConvert = allStoreOfAccount?.data?.map((item: any) => {
        return {
          value: item?.groupId,
          label: item?.groupId,
        };
      });
      if (listStoreConvert) {
        setListStoreSelect(listStoreConvert);
        if (!storeCode) {
          setStoreId(listStoreConvert?.[0]?.value || "");
        }
      }
    }
  }, [allStoreOfAccount?.data]);

  useEffect(() => {
    setListRevenueMachine(revenueMachine?.data);
    if (revenueMachine?.data) {
      const dataConfig = {
        couponPrice: revenueMachine?.data?.couponPrice,
        f1Counter: revenueMachine?.data?.f1Counter,
        groupName: revenueMachine?.data?.groupName,
        quantity: revenueMachine?.data?.quantity || 0,
        revenueTotal: revenueMachine?.data?.revenueTotal || 0,
        totalCoupon: revenueMachine?.data?.totalCoupon,
        totalF1: revenueMachine?.data?.totalF1,
        userGroup: revenueMachine?.data?.userGroup,
      };
      setDataRevenue(dataConfig);
    }
  }, [revenueMachine?.data, isLoading]);

  const { end, start } = getStartEndOfCurrentMonth();

  useEffect(() => {
    if (startDate && endDate) {
      setStartDate(startDate);
      setEndDate(endDate);
    } else {
      setStartDate(start);
      setEndDate(end);
    }
  }, [start, end]);

  const handleChange = (value: string) => {
    setStoreId(value);
  };

  return (
    <>
      {isLoading ? (
        <LoaderCustom></LoaderCustom>
      ) : (
        <div className="w-full md:px-0 px-2">
          <div className="w-[100%] max-md:mt-4 items-center md:pb-2 mt-4 font-semibold text-ok-travel-green flex pb-4 lg:pb-0 justify-between mb-2 border-b-[1.5px] md:mb-4">
            <h3 className="uppercase px-[16px] md:px-[0px] text-medium text-gray-500 md:text-md xl:text-xl">
              Manage Machine
            </h3>
          </div>
          <div className="mb-4">
            <div className="grid grid-cols-2 max-sm:text-[12px] text-sm lg:w-[40%] items-center gap-4">
              {/* == filter date */}
              <div className="">
                <Dropdown
                  overlay={
                    <RangeCalendar
                      className="fixed"
                      onChange={(value) => {
                        setStartDate(
                          `${value.start.year}-${
                            value.start.month < 10
                              ? `0${value.start.month}`
                              : value.start.month
                          }-${
                            value.start.day < 10
                              ? `0${value.start.day}`
                              : value.start.day
                          }`
                        );

                        setEndDate(
                          `${value.end.year}-${
                            value.end.month < 10
                              ? `0${value.end.month}`
                              : value.end.month
                          }-${
                            value.end.day < 10
                              ? `0${value.end.day}`
                              : value.end.day
                          }`
                        );
                        setIsShowCalender(false);
                      }}
                      aria-label="Date (No Selection)"
                    />
                  }
                  trigger={["click"]}
                >
                  <div
                    // onClick={() => setIsShowCalender(!isShowCalender)}
                    className="flex max-sm:text-[12px] text-sm text-gray-400 gap-2 my-4 cursor-pointer justify-between lg:px-4 px-2 py-1 border-[1px] border-gray-300 rounded-full bg-white"
                  >
                    <span className="text-gray-400 max-sm:text-[12px] text-sm">
                      {startDate && endDate
                        ? `from ${formatMonthDate(
                            startDate
                          )} to ${formatMonthDate(endDate)}`
                        : "Filter date"}
                    </span>
                    {!startDate && !endDate && <ScheduleOutlined />}
                  </div>
                </Dropdown>
              </div>
              <div className="max-sm:text-[12px] text-sm overflow-hidden">
                <Select
                  placeholder="Select by store id"
                  className="w-full placeholder:max-sm:text-[12px] rounded-full border-1 bg-transparent placeholder:text-sm max-sm:text-[12px] text-sm"
                  options={listStoreSelect}
                  onChange={handleChange}
                  value={storeId}
                ></Select>
              </div>
            </div>
          </div>

          {dataRevenue && (
            <CardItemRevenueStore
              isShowBtn={false}
              data={dataRevenue}
            ></CardItemRevenueStore>
          )}

          {listRevenueMachine?.dateResponses?.length === 0 ? (
            <div className="w-full h-full flex-col gap-2 flex max-lg:mt-20 justify-center items-center">
              <img
                className="max-md:w-[12rem]"
                alt="icon-empty"
                src={emptyIcon}
              ></img>
              <span className="text-gray-500">Select a store</span>
            </div>
          ) : (
            <table className="mt-4 w-full lg:bg-white">
              <tr className="pt-1 lg:grid lg:grid-cols-[repeat(13,minmax(0,1fr))] hidden bg-photo-time-pink-light bg-opacity-25 h-[4vh] text-gray-600 items-center w-full lg:gap-x-1 xl:gap-x-2">
                <th className="text-xs lg:text-sm min-w-0">MACHINE ID</th>
                <th className="text-xs lg:text-sm min-w-0">NAME</th>
                <th className="text-xs lg:text-sm min-w-0">REVENUE</th>
                <th className="text-xs lg:text-sm min-w-0">COUPON</th>
                <th className="text-xs lg:text-sm min-w-0">TOTAL INCOME</th>
                <th className="max-lg:hidden text-xs lg:text-sm min-w-0">10K</th>
                <th className="max-lg:hidden text-xs lg:text-sm min-w-0">20K</th>
                <th className="max-lg:hidden text-xs lg:text-sm min-w-0">30K</th>
                <th className="max-lg:hidden text-xs lg:text-sm min-w-0">40K</th>
                <th className="max-lg:hidden text-xs lg:text-sm min-w-0">50K</th>
                <th className="max-lg:hidden text-xs lg:text-sm min-w-0">60K</th>
                <th className="max-lg:hidden text-xs lg:text-sm min-w-0">70K</th>
                <th className="max-lg:hidden text-xs lg:text-sm min-w-0">100K</th>
              </tr>
              {listRevenueMachine?.dateResponses?.length > 0 &&
                listRevenueMachine?.dateResponses?.map(
                  (item: any, index: number) => {
                    return (
                      <div
                        key={index}
                        className="lg:bg-transparent bg-gray-300 bg-opacity-15 px-[12px] rounded-xl"
                      >
                        <div>
                          <tr className="grid grid-cols-5 lg:hidden bg-photo-time-pink-light bg-opacity-25 h-[4vh] text-gray-600 items-center w-full">
                            <th className="text-[10px] sm:text-sm">MACHINE ID</th>
                            <th className="text-[10px] sm:text-sm">NAME</th>
                            <th className="text-[10px] sm:text-sm">REVENUE</th>
                            <th className="text-[10px] sm:text-sm">COUPON</th>
                            <th className="text-[10px] sm:text-sm">TOTAL INCOME</th>
                          </tr>
                        </div>
                        <div>
                          <tr
                            className={`grid ${
                              index % 2 === 0 && "bg-gray-300 bg-opacity-20"
                            } lg:grid-cols-[repeat(13,minmax(0,1fr))] lg:gap-x-1 xl:gap-x-2 lg:py-3 grid-cols-5 my-2`}
                          >
                            <td className="text-center text-xs sm:text-sm lg:text-sm flex justify-center items-center min-w-0">
                              {item?.userId}
                            </td>
                            <td className="flex flex-col justify-center text-xs sm:text-sm lg:text-sm items-center gap-0.5 min-w-0 max-w-full">
                              {item?.userName}
                            </td>
                            <tr className="flex flex-col justify-center text-xs sm:text-sm lg:text-sm items-center gap-0.5 min-w-0">
                              <td>{item?.countMon}</td>
                              <td className="text-green-500 font-semibold">{formatNumberWithCommas(item?.totMon)}</td>
                            </tr>
                            <tr className="flex flex-col justify-center text-xs sm:text-sm lg:text-sm items-center gap-0.5 min-w-0">
                              <td>{item?.totalCoupon}</td>
                              <td className="text-green-500 font-semibold">{formatNumberWithCommas(item?.totalCouponMonth)}</td>
                            </tr>
                            <td className="flex flex-col justify-center text-xs sm:text-sm lg:text-sm text-green-500 font-semibold items-center gap-0.5 min-w-0">
                              {formatNumberWithCommas(item?.totMon - item?.totalCouponMonth)}
                            </td>
                            <tr className="flex text-center max-lg:hidden flex-col justify-center items-center gap-0.5 min-w-0">
                              <td className="text-xs sm:text-sm lg:text-sm">{item?.totalCoupon10}</td>
                              <td className="text-xs sm:text-sm lg:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon10)}</td>
                            </tr>
                            <tr className="flex text-center max-lg:hidden flex-col justify-center items-center gap-0.5 min-w-0">
                              <td className="text-xs sm:text-sm lg:text-sm">{item?.totalCoupon20}</td>
                              <td className="text-xs sm:text-sm lg:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon20)}</td>
                            </tr>
                            <tr className="flex max-lg:hidden flex-col justify-center items-center gap-0.5 min-w-0">
                              <td className="text-xs sm:text-sm lg:text-sm">{item?.totalCoupon30}</td>
                              <td className="text-xs sm:text-sm lg:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon30)}</td>
                            </tr>
                            <tr className="flex max-lg:hidden flex-col justify-center items-center gap-0.5 min-w-0">
                              <td className="text-xs sm:text-sm lg:text-sm">{item?.totalCoupon40}</td>
                              <td className="text-xs sm:text-sm lg:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon40)}</td>
                            </tr>
                            <tr className="flex max-lg:hidden flex-col justify-center items-center gap-0.5 min-w-0">
                              <td className="text-xs sm:text-sm lg:text-sm">{item?.totalCoupon50}</td>
                              <td className="text-xs sm:text-sm lg:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon50)}</td>
                            </tr>
                            <tr className="flex max-lg:hidden flex-col justify-center items-center gap-0.5 min-w-0">
                              <td className="text-xs sm:text-sm lg:text-sm">{item?.totalCoupon60}</td>
                              <td className="text-xs sm:text-sm lg:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon60)}</td>
                            </tr>
                            <tr className="flex max-lg:hidden flex-col justify-center items-center gap-0.5 min-w-0">
                              <td className="text-xs sm:text-sm lg:text-sm">{item?.totalCoupon70}</td>
                              <td className="text-xs sm:text-sm lg:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon70)}</td>
                            </tr>
                            <tr className="flex max-lg:hidden flex-col justify-center items-center gap-0.5 min-w-0">
                              <td className="text-xs sm:text-sm lg:text-sm">{item?.totalCoupon100}</td>
                              <td className="text-xs sm:text-sm lg:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon100)}</td>
                            </tr>
                          </tr>
                        </div>
                        <div>
                          <tr className="grid grid-cols-8 lg:hidden bg-yellow-300 bg-opacity-25 h-[4vh] text-gray-600 items-center w-full">
                            <th className="text-[10px] sm:text-sm">10K</th>
                            <th className="text-[10px] sm:text-sm">20K</th>
                            <th className="text-[10px] sm:text-sm">30K</th>
                            <th className="text-[10px] sm:text-sm">40K</th>
                            <th className="text-[10px] sm:text-sm">50K</th>
                            <th className="text-[10px] sm:text-sm">60K</th>
                            <th className="text-[10px] sm:text-sm">70K</th>
                            <th className="text-[10px] sm:text-sm">100K</th>
                          </tr>
                        </div>
                        <div>
                          <tr className="grid mb-9 lg:hidden grid-cols-8 my-2">
                            <tr className="flex flex-col justify-center items-center gap-0.5">
                              <td className="text-xs sm:text-sm">{item?.totalCoupon10}</td>
                              <td className="text-xs sm:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon10)}</td>
                            </tr>
                            <tr className="flex flex-col justify-center items-center gap-0.5">
                              <td className="text-xs sm:text-sm">{item?.totalCoupon20}</td>
                              <td className="text-xs sm:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon20)}</td>
                            </tr>
                            <tr className="flex flex-col justify-center items-center gap-0.5">
                              <td className="text-xs sm:text-sm">{item?.totalCoupon30}</td>
                              <td className="text-xs sm:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon30)}</td>
                            </tr>
                            <tr className="flex flex-col justify-center items-center gap-0.5">
                              <td className="text-xs sm:text-sm">{item?.totalCoupon40}</td>
                              <td className="text-xs sm:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon40)}</td>
                            </tr>
                            <tr className="flex flex-col justify-center items-center gap-0.5">
                              <td className="text-xs sm:text-sm">{item?.totalCoupon50}</td>
                              <td className="text-xs sm:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon50)}</td>
                            </tr>
                            <tr className="flex flex-col justify-center items-center gap-0.5">
                              <td className="text-xs sm:text-sm">{item?.totalCoupon60}</td>
                              <td className="text-xs sm:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon60)}</td>
                            </tr>
                            <tr className="flex flex-col justify-center items-center gap-0.5">
                              <td className="text-xs sm:text-sm">{item?.totalCoupon70}</td>
                              <td className="text-xs sm:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon70)}</td>
                            </tr>
                            <tr className="flex flex-col justify-center items-center gap-0.5">
                              <td className="text-xs sm:text-sm">{item?.totalCoupon100}</td>
                              <td className="text-xs sm:text-sm text-green-500 font-semibold">{formatNumberWithCommas(item?.countCoupon100)}</td>
                            </tr>
                          </tr>
                        </div>
                      </div>
                    );
                  }
                )}
            </table>
          )}
          <FooterFilterMobile isFilter={true}>
            {/* Mobile */}
          </FooterFilterMobile>
        </div>
      )}
    </>
  );
}
